//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mergeDeep } from '~/helpers/objects'
import breakpointMixin from '~/mixins/breakpointMixin'

export default {
  name: 'BaseSwiper',

  mixins: [breakpointMixin],
  
  props: {
    disableOnDesktop: { type: Boolean, default: true }
  },

  data () {
    return {
      defaults: {
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: false,
          clickable: true
        }
      }
    }
  },
  
  computed: {
    swiperOptions () {
      return mergeDeep(this.defaults, this.$attrs || {})
    }
  },

  methods: {
    slideTo (slideIndex) {
      if (this.swiper) this.swiper.slideTo(slideIndex)
    },
    disable () {
      if (this.swiper) this.swiper.disable()
    },
    enable () {
      if (this.swiper) this.swiper.enable()
    }
  }
}
